import React, { useEffect, ReactNode } from 'react';

interface PageProps {
    title: string;
    children: ReactNode;
}

const PageWithTitle = ({ title, children }: PageProps) => {
    useEffect(() => {
        document.title = title;
    }, [title]);

    return <>{children}</>;
};

export default PageWithTitle;
